import { Button } from 'components/ui'
import React, { useCallback, useState } from 'react'
import { Box, Flex, Text, Tooltip } from '@chakra-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import useLocaleText from 'components/useLocaleText'
import { WatchersModal } from './WatchersModal'
import { WatchersAvatars } from './WatchersAvatars'
import { WidgetWrapper } from 'components/TasksV2/UI/WidgetWrapper'
import { FormInputLabel } from 'components/TasksV2/UI/FormInputLabel'
import { CgEyeAlt } from 'react-icons/cg'

const WatchersContent: React.FC = () => {
  const { setValue, watch, errors } = useFormContext()
  const uid = useSelector((state: RootState) => state.auth.uid)
  const theme = useSelector((state: RootState) => state.general.theme)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const t_update_watchers = useLocaleText('update_watchers') || 'Update Watchers'
  const watchersTooltip =
    useLocaleText('watchers_tooltip') || 'Watchers are the users who will be notified about the task'

  const t_watchers = useLocaleText('watchers')

  const currentWatchers = watch('watchers') || []

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleSubmit = useCallback(
    (selectedWatchers: string[]) => {
      // If no watchers selected, add creator (current user) by default
      if (selectedWatchers.length === 0 && uid) {
        setValue('watchers', [uid])
      } else {
        setValue('watchers', selectedWatchers)
      }
    },
    [setValue, uid]
  )

  return (
    <>
      <Tooltip label={watchersTooltip} aria-label={watchersTooltip} hasArrow placement="bottom" zIndex={10000}>
        <Flex alignItems="center" style={{ columnGap: '10px' }}>
          <WidgetWrapper
            flexDir="row"
            alignItems="center"
            justifyContent="space-between"
            isError={!!errors?.watchers}
            p="10px"
            w="100%"
          >
            <Text>{t_watchers}</Text>
            {currentWatchers.length > 0 && <WatchersAvatars watcherIds={currentWatchers} maxVisible={5} />}
            <Button
              type="button"
              size="sm"
              onClick={handleOpenModal}
              bg={theme?.elementsColor}
              color="white"
              w="max-content"
            >
              <Text>{t_update_watchers}</Text>
            </Button>
          </WidgetWrapper>
          <Flex alignItems="center" justifyContent="center" bg="#ababab" p="6px" borderRadius="full">
            <CgEyeAlt size={18} color="white" />
          </Flex>
        </Flex>
      </Tooltip>
      <WatchersModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        initialWatchers={currentWatchers}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export const ChooseWatchers: React.FC = () => {
  const { control } = useFormContext()

  const t_update_watchers = useLocaleText('update_watchers') || 'Update Watchers'

  return (
    <Box>
      <FormInputLabel label={t_update_watchers} isRequired />
      <Controller name="watchers" control={control} as={<WatchersContent />} />
    </Box>
  )
}
